import { QuestContractWriteFunctionNames, Tiers } from '../constants/types';
import { Abi, PublicClient, WalletClient } from 'viem';

import QUEST_ABI from './quest-abi.json';

const QUEST_CONTRACT_ADDRESS = import.meta.env.VITE_QUEST_CONTRACT as `0x${string}`;

const writeContractCall = async <T>(
  publicClient: PublicClient,
  walletClient: WalletClient,
  address: `0x${string}`,
  abi: Abi,
  functionName: QuestContractWriteFunctionNames,
  args: readonly unknown[] = [],
  account: `0x${string}`,
): Promise<T> => {
  try {
    const { request } = await publicClient.simulateContract({
      address,
      abi,
      functionName,
      args,
      account,
    });
    return (await walletClient.writeContract({ ...request })) as T;
  } catch (error) {
    console.error(`Error writing ${functionName}:`, error);
    throw new Error(`Failed to write ${functionName}`);
  }
};

export const writeMint = (
  publicClient: PublicClient,
  walletClient: WalletClient,
  tier: Tiers,
  amount: number,
  account: `0x${string}`,
) =>
  // tier here 1,2,3. so it is first tier for every move
  //ammount is how many nfts to mint (can mint many nfrts in one call)
  writeContractCall<`0x${string}`>(
    publicClient,
    walletClient,
    QUEST_CONTRACT_ADDRESS,
    QUEST_ABI as Abi,
    QuestContractWriteFunctionNames.MINT,
    [tier, amount],
    account,
  );

export const writeForge = (
  publicClient: PublicClient,
  walletClient: WalletClient,
  tier: Tiers,
  amount: number,
  account: `0x${string}`,
) =>
  // tier here is from what tier to forge
  // amount is how many nfts to forge (can forge one next tier nft in one call, so amount is how much we burn to forge)
  writeContractCall<`0x${string}`>(
    publicClient,
    walletClient,
    QUEST_CONTRACT_ADDRESS,
    QUEST_ABI as Abi,
    QuestContractWriteFunctionNames.FORGE,
    [tier, amount],
    account,
  );

export const writeRunDailyQuest = (
  publicClient: PublicClient,
  walletClient: WalletClient,
  account: `0x${string}`,
) =>
  writeContractCall<`0x${string}`>(
    publicClient,
    walletClient,
    QUEST_CONTRACT_ADDRESS,
    QUEST_ABI as Abi,
    QuestContractWriteFunctionNames.RUN_DAILY_QUEST,
    [],
    account,
  );
